import { FormResponse } from "@tellescope/types-models";
import { useEnduserCurrentEnduser, useEnduserStore } from "../../../store/hooks";
import { useOrganization } from "../../../../shared/store/organizationStore";
import { EnduserFormWizard, type EnduserFormWizardProps } from "@tellescope/forms";

interface PendingFormContentProps {
  formResponse: FormResponse;
  onComplete: () => void;
  continueToFormInApp?: EnduserFormWizardProps["continueToFormInApp"];
}

export const PendingFormContent = ({ formResponse, onComplete, continueToFormInApp }: PendingFormContentProps) => {
  const currentEnduser = useEnduserCurrentEnduser();
  const session = useEnduserStore((state) => state.session);
  const organization = useOrganization();

  const enduserId = currentEnduser?.id ?? formResponse.enduserId;

  if (!formResponse.accessCode || !currentEnduser) {
    return null;
  }

  return (
    <EnduserFormWizard
      formArgs={{
        formId: formResponse.formId,
        formTitle: formResponse.formTitle,
        responseId: formResponse.id,
        enduserId,
        parentResponseId: formResponse.parentResponseId,
        rootResponseId: formResponse.rootResponseId,
        existingResponses: formResponse.responses,
        accessCode: formResponse.accessCode ?? "",
        enduser: currentEnduser,
      }}
      onComplete={onComplete}
      session={session}
      organizationSubdomain={organization?.subdomain}
      orgLogoSrc={organization?.logoURL}
      continueToFormInApp={continueToFormInApp}
    />
  );
};
